import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Cookies from "js-cookie";

import { getAlphaMdMessages, ALPHAMD_SENDER_ID } from '@/services/alphaMdMessages';

export const refreshAlphaMdMessages = createAsyncThunk('chat/refreshAlphaMdMessages', async () => getAlphaMdMessages());

// Async thunk to fetch messages
export const fetchMessages = createAsyncThunk(
    'chat/fetchMessages',
    async ({ userId, page, limit, search='' }, { rejectWithValue }) => {
        try {
            let token = Cookies.get('token');

            if (!token) {
                console.log('Token Not found in chat module')
            }

            const response = await axios.get(`${process.env.NEXT_PUBLIC_BASE_URL}/messages/${userId}`, {
                params: { page, limit, search },
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching messages:', error);
            return rejectWithValue(error.response?.data || { message: 'Could not load messages.' });
        }
    }
);

export const fetchConversation = createAsyncThunk('chat/fetchConversation', async ({ counterpartyId, messageId }, { rejectWithValue }) => {
    try {
        const { data } = await axios.get(`${process.env.NEXT_PUBLIC_BASE_URL}/messages/conversations/${counterpartyId}`, {
            params: { messageId }, headers: { Authorization: `Bearer ${Cookies.get('token')}` }
        });
        return data;
    } catch (error) { return rejectWithValue(error.response?.data || { message: 'Could not open this conversation.' }); }
});

export const readConversation = createAsyncThunk('chat/readConversation', async ({ counterpartyId, throughMessageId }, { rejectWithValue }) => {
    try {
        const { data } = await axios.post(`${process.env.NEXT_PUBLIC_BASE_URL}/messages/conversations/${counterpartyId}/read`,
            { throughMessageId }, { headers: { Authorization: `Bearer ${Cookies.get('token')}` } });
        return data.data;
    } catch (error) { return rejectWithValue(error.response?.data || { message: 'Could not mark messages as read.' }); }
});

const boundaryTime = boundary => new Date(boundary.throughCreatedAt).getTime();
function applyReadBoundary(state, boundary) {
    const { receiverId, senderId, throughMessageId, throughCreatedAt, unreadCount } = boundary;
    if (!throughMessageId || !throughCreatedAt) return;
    const key = `${senderId}:${receiverId}`, previous = state.readBoundaries[key];
    if (previous && (boundaryTime(previous) > boundaryTime(boundary) ||
        (boundaryTime(previous) === boundaryTime(boundary) && previous.throughMessageId >= throughMessageId))) return;
    state.readBoundaries[key] = boundary;
    state.messages.filter(chat => chat.id === receiverId || chat.id === senderId).forEach(chat => {
        let readCount = 0;
        chat.messages.forEach(message => {
            const timestamp = new Date(message.createdAt).getTime();
            const before = timestamp < boundaryTime(boundary) || (timestamp === boundaryTime(boundary) && message._id <= throughMessageId);
            if (before && message.senderId === senderId && message.receiverId === receiverId && message.status !== 'read') {
                message.status = 'read'; readCount++;
            }
        });
        if (chat.lastMessage && chat.messages.some(message => message._id === chat.lastMessage._id && message.status === 'read')) chat.lastMessage.status = 'read';
        if (chat.id !== senderId) return;
        const priorCount = chat.unreadCount || 0;
        const newerUnread = chat.messages.filter(message => message.senderId === senderId && message.receiverId === receiverId && message.status !== 'read').length;
        chat.unreadCount = Number.isInteger(unreadCount) ? Math.max(unreadCount, newerUnread) : Math.max(0, priorCount - readCount);
        state.totalUnreadCount = Math.max(0, state.totalUnreadCount - priorCount + chat.unreadCount);
    });
}

const chatSlice = createSlice({
    name: 'chat',
    initialState: {
        messages: [],
        users: [],
        readBoundaries: {},
        listRequestId: null,
        totalUnreadCount: 0,
        currentUserId: null,
        chatLoader: false,
        hasFetched: false,
        openedConversationId: null,
        alphaRequestId: null,
        currentPage: 1, // Add currentPage to state
        totalPages: 0,  // Add totalPages to state
        messagesPerPage: 10, // Define how many messages per page
        hasMore: true
    },
    reducers: {
        addMessage: (state, action) => {
            console.log('state.messages_MAIN', state, action)
            const message = action.payload.data || action.payload;
            const { receiverId, senderId, text } = message;
            if (!message._id) return;
            console.log('{ receiverId, senderId, text } ',{ receiverId, senderId, text } )
            let chatIndex = state.messages.findIndex(chat => chat.id === receiverId || chat.id === senderId);
            console.log('chatIndex',chatIndex)

            if (chatIndex !== -1) {

                if (action.payload?.appointmentId?.parentId && action.payload?.appointmentId?.isRescheduled) {
                    let rescheduleChatIndex = state.messages[chatIndex].messages.findIndex(chat => chat?.appointmentId?._id === action.payload?.appointmentId?.parentId);
                    if (rescheduleChatIndex !== -1) {
                        state.messages[chatIndex].messages[rescheduleChatIndex]['appointmentId'].isCancelled = true;
                    }
                }
                const message = action.payload.data || action.payload;
                if (state.messages[chatIndex].messages.some(item => item._id === message._id)) return;
                state.messages[chatIndex].messages.push(message);
                state.messages[chatIndex].lastMessage = message;
                if (message.receiverId === state.currentUserId && message.status !== 'read') {
                    state.messages[chatIndex].unreadCount = (state.messages[chatIndex].unreadCount || 0) + 1;
                    state.totalUnreadCount++;
                }
                // Move the chat to the top
                const chat = state.messages.splice(chatIndex, 1)[0];
                console.log('chayt',chat)
                state.messages.unshift(chat);
            }
        },

        cancelMeeting: (state, action) => {
            const { receiverId, senderId } = action.payload;

            let chatIndex = state.messages.findIndex(chat => chat.id === receiverId || chat.id === senderId);

            if (chatIndex !== -1) {

                if (action.payload?.appointmentId) {
                    let rescheduleChatIndex = state.messages[chatIndex].messages.findIndex(chat => chat?.appointmentId?._id === action.payload?.appointmentId);
                    if (rescheduleChatIndex !== -1) {
                        state.messages[chatIndex].messages[rescheduleChatIndex]['appointmentId'].isCancelled = true;
                    }
                }
            }
        },
        scheduleRequestedMeetingWithReps: (state, action) => {
            const { receiverId, senderId, appointmentId, requestedAppointmentId } = action.payload;

            let chatIndex = state.messages.findIndex(chat => chat.id === receiverId || chat.id === senderId);

            if (chatIndex !== -1) {

                if (action.payload?.requestedAppointmentId) {
                    let rescheduleChatIndex = state.messages[chatIndex].messages.findIndex(chat => chat?.requestedAppointmentId?._id === action.payload?.requestedAppointmentId);
                    console.log('rescheduleChatIndex', rescheduleChatIndex, 'chatIndex', chatIndex)
                    if (rescheduleChatIndex !== -1) {
                        state.messages[chatIndex].messages[rescheduleChatIndex]['requestedAppointmentId'].isScheduled = true;
                        state.messages[chatIndex].messages[rescheduleChatIndex]['requestedAppointmentId'].appointmentId = appointmentId;
                    }
                }
            }
        },

        cancelRequestedMeetingWithReps: (state, action) => {
            const { receiverId, senderId, requestedAppointmentId } = action.payload;

            let chatIndex = state.messages.findIndex(chat => chat.id === receiverId || chat.id === senderId);

            if (chatIndex !== -1) {

                if (action.payload?.requestedAppointmentId) {
                    let rescheduleChatIndex = state.messages[chatIndex].messages.findIndex(chat => chat?.requestedAppointmentId?._id === action.payload?.requestedAppointmentId);
                    console.log('rescheduleChatIndex', rescheduleChatIndex, 'chatIndex', chatIndex)
                    if (rescheduleChatIndex !== -1) {
                        state.messages[chatIndex].messages[rescheduleChatIndex]['requestedAppointmentId'].isCancelled = true;
                        state.messages[chatIndex].messages[rescheduleChatIndex]['requestedAppointmentId'].cancelledBy = senderId;
                    }
                }
            }
        },
        confirmMeetingFromReps: (state, action) => {
            const { receiverId, senderId } = action.payload;

            let chatIndex = state.messages.findIndex(chat => chat.id === receiverId || chat.id === senderId);

            if (chatIndex !== -1) {

                if (action.payload?.appointmentId) {
                    let rescheduleChatIndex = state.messages[chatIndex].messages.findIndex(chat => chat?.appointmentId?._id === action.payload?.appointmentId);
                    if (rescheduleChatIndex !== -1) {
                        state.messages[chatIndex].messages[rescheduleChatIndex]['appointmentId'].rescheduleApproved = true;
                        state.messages[chatIndex].messages[rescheduleChatIndex]['appointmentId'].isApproved = true;
                    }
                }
            }
        },
        confirmMeeting: (state, action) => {
            const { receiverId, senderId } = action.payload;

            let chatIndex = state.messages.findIndex(chat => chat.id === receiverId || chat.id === senderId);
            console.log('chatIndex',chatIndex)

            if (chatIndex !== -1) {

                if (action.payload?.appointmentId) {
                    let rescheduleChatIndex = state.messages[chatIndex].messages.findIndex(chat => chat?.appointmentId?._id === action.payload?.appointmentId);
                    if (rescheduleChatIndex !== -1) {
                        state.messages[chatIndex].messages[rescheduleChatIndex]['appointmentId'].rescheduleApproved = true;
                        state.messages[chatIndex].messages[rescheduleChatIndex]['appointmentId'].isApproved = true;
                    }
                }
            }
        },
        receiveMessage: (state, action) => {
            console.log(state, action, "receiveMessage")
            const { senderId, text } = action.payload;
            let chatIndex = state.messages.findIndex(chat => {
                console.log("receiveMessage", chat.id, senderId)
                return chat.id === senderId
            });
            console.log("receiveMessage", chatIndex)

            if (chatIndex !== -1) {
                console.log('action.payload', action.payload?.appointmentId?.parentId)
                if (action.payload?.appointmentId?.parentId && action.payload?.appointmentId?.isRescheduled) {
                    let rescheduleChatIndex = state.messages[chatIndex].messages.findIndex(chat => chat?.appointmentId?._id === action.payload?.appointmentId?.parentId);
                    if (rescheduleChatIndex !== -1) {
                        state.messages[chatIndex].messages[rescheduleChatIndex]['appointmentId'].isCancelled = true;
                    }
                }
                const message = action.payload.data || action.payload;
                if (!message._id || state.messages[chatIndex].messages.some(item => item._id === message._id)) return;
                state.messages[chatIndex].messages.push(message);
                state.messages[chatIndex].lastMessage = message;
                if (message.receiverId === state.currentUserId && message.status !== 'read') {
                    state.messages[chatIndex].unreadCount = (state.messages[chatIndex].unreadCount || 0) + 1;
                    state.totalUnreadCount++;
                }
                // Move the chat to the top
                const chat = state.messages.splice(chatIndex, 1)[0];
                state.messages.unshift(chat);
            }
        },

        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setMessagesPerPage: (state, action) => {
            state.messagesPerPage = action.payload;
        },

        setOpenedConversationId: (state, action) => { state.openedConversationId = action.payload; },

        markMessagesAsRead: (state, action) => {
            applyReadBoundary(state, action.payload);
        },

        setMessageStatus: (state, action) => {
            const { messageId, status } = action.payload;
            let chat = state.messages.find(chat => chat.messages.some(message => message._id === messageId));
            if (chat) {
                const message = chat.messages.find(msg => msg._id === messageId);
                if (message && message.status !== 'read') message.status = status;
            }
        },
        setUserList: (state, action) => {
            state.users = action.payload;
        },
        setCurrentUserId: (state, action) => {
            state.currentUserId = action.payload;
        },
        clearChatState: (state) => {
                state.messages = [];
                state.users = [];
                state.readBoundaries = {};
                state.listRequestId = null;
                state.openedConversationId = null;
                state.alphaRequestId = null;
                state.totalUnreadCount = 0;
                state.currentUserId = null;
                state.chatLoader = false;
                state.hasFetched = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(readConversation.fulfilled, (state, action) => applyReadBoundary(state, action.payload))
            .addCase(refreshAlphaMdMessages.pending, (state, action) => { state.alphaRequestId = action.meta.requestId; })
            .addCase(refreshAlphaMdMessages.fulfilled, (state, action) => {
                if (state.alphaRequestId !== action.meta.requestId) return;
                const conversation = action.payload.data;
                const previousUnread = state.messages.find(chat => chat.id === ALPHAMD_SENDER_ID)?.unreadCount || 0;
                state.messages = state.messages.filter(chat => chat.id !== ALPHAMD_SENDER_ID);
                if (conversation) state.messages.push(conversation);
                state.messages.sort((a, b) => new Date(b.lastMessage?.createdAt || 0) - new Date(a.lastMessage?.createdAt || 0));
                // An official-thread refresh must not overwrite a newer read
                // acknowledgement in another conversation.
                state.totalUnreadCount = Math.max(0, state.totalUnreadCount - previousUnread + (conversation?.unreadCount || 0));
            })
            .addCase(fetchConversation.fulfilled, (state, action) => {
                const conversation = action.payload.data[0];
                if (!conversation) return;
                state.openedConversationId = conversation.id;
                state.messages = [conversation, ...state.messages.filter(chat => chat.id !== conversation.id)];
            })
            .addCase(fetchMessages.pending, (state, action) => {
                state.listRequestId = action.meta.requestId;
                state.currentUserId = action.meta.arg.userId;
                if (!state.hasFetched) {
                    state.chatLoader = true;
                }
            })
            .addCase(fetchMessages.fulfilled, (state, action) => {
                if (state.listRequestId && state.listRequestId !== action.meta.requestId) return;
                state.chatLoader = false;
                const newMessages = action?.payload?.data;

                const systemConversation = state.messages.find(chat => chat.id === ALPHAMD_SENDER_ID);
                const page = action.meta.arg.page || 1;
                state.hasMore = newMessages.length >= (action.meta.arg.limit || 10);
                const merged = page === 1 ? [...newMessages] : [...state.messages, ...newMessages];
                const opened = state.messages.find(chat => chat.id === state.openedConversationId);
                if (opened && !merged.some(chat => chat.id === opened.id)) merged.push(opened);
                // Preserve the independently refreshed system thread, including when
                // a notification opens a conversation beyond the first list page.
                if (systemConversation && !merged.some(chat => chat.id === ALPHAMD_SENDER_ID)) merged.push(systemConversation);
                state.messages = [...new Map(merged.map(chat => [chat.id, chat.id === ALPHAMD_SENDER_ID && systemConversation?.cases ? { ...chat, cases: systemConversation.cases } : chat])).values()];
                state.messages.sort((a, b) => new Date(b.lastMessage?.createdAt || 0) - new Date(a.lastMessage?.createdAt || 0));
                state.totalUnreadCount = action?.payload?.totalUnreadCount;
                state.totalPages = action?.payload?.totalPages;
                state.hasFetched = true;
            })
            .addCase(fetchMessages.rejected, (state, action) => {
                if (state.listRequestId !== action.meta.requestId) return;
                state.chatLoader = false;
                state.hasFetched = true;
            });
    },
});

export const {
    addMessage,
    scheduleRequestedMeetingWithReps,
    cancelRequestedMeetingWithReps,
    confirmMeetingFromReps,
    cancelMeeting,
    confirmMeeting,
    markMessagesAsRead,
    setCurrentPage,
    setMessagesPerPage,
    setOpenedConversationId,
    receiveMessage,
    setMessageStatus,
    setUserList,
    setCurrentUserId,
    clearChatState
} = chatSlice.actions;

export default chatSlice.reducer;
